import { AddContactButton } from '../AddContactButton/AddContactButton';
import {
  StyledContactsCount,
  StyledHeading,
  StyledPageHeaderContainer
} from '../PageHeader/PageHeader.styles';
import { CONTACT_FORM } from '../../../../constants/modals';
import { useAppDispatch, useAppSelector } from '../../../../helpers/store';
import { initializeContactForm } from '../../../../actions/contactForm.actions';
import { openModal } from '../../../../actions/common.actions';
import { selectCanAddMember } from '../../../../reducers/authentication.reducer';
import { RootState } from '../../../../reducers/index.types';

export const ContactsHeader = () => {
  const dispatch = useAppDispatch();
  const contactsCount = useAppSelector(
    (state: RootState) => state.contactsData?.contactsTotalNumber || 0
  );
  const canAddMember = useAppSelector(selectCanAddMember);

  const handleAddNewClick = () => {
    dispatch(initializeContactForm(null));
    dispatch(openModal(CONTACT_FORM, { maxWidth: 'sm' }));
  };
  // Return null if not on contacts page
  if (!window.location.href.includes('/sampark/contacts')) {
    return null;
  }

  return (
    <StyledPageHeaderContainer>
      <StyledHeading>
        Contacts
        <StyledContactsCount> {contactsCount}</StyledContactsCount>
      </StyledHeading>
      {canAddMember ? <AddContactButton onClick={handleAddNewClick} /> : null}
    </StyledPageHeaderContainer>
  );
};
